import { message } from 'antd';
import { callApi } from '../../api';
import { MethodType } from '../../common/constants';

export const fetchMCPServerCategories = async () => {
    const response = await callApi({
        url: 'mcp/getmcpcategories',
        method: MethodType.GET,
    });
    return response.resp.data ?? [];
};

export const fetchMCPServerApps = async () => {
    const response = await callApi({
        url: 'mcp/getmcpapps',
        method: MethodType.GET,
    });
    return response.resp.data;
};

export const fetchMCPServerAppDetails = async (id) => {
    const response = await callApi({
        url: 'mcp/getmcpappdetails',
        method: MethodType.GET,
        data: { id: id },
    });
    return response.resp.data;
};

export const saveMCPServerAppDetails = async (id, data) => {
    const response = await callApi({
        url: 'mcp/savemcpappdetails',
        method: MethodType.POST,
        data: { id: id, ...data },
    });

    if (!validateMCPApiResponse(response)) {
        throw new Error('Failed to save MCP Server App Details');
    }
    return response.resp.data;
};

export const updateMCPServerCompletionStatus = async (id, completionStatus) => {
    const response = await callApi({
        url: 'mcp/updatecompletionstatus',
        method: MethodType.POST,
        data: { id: id, completionStatus: completionStatus },
    });

    console.log('completionStatus api :', response.resp);

    if (!validateMCPApiResponse(response)) {
        throw new Error(response.resp?.message ?? 'Failed to update MCP Server Completion Status');
    }

    return response.resp;
};

export const addMCPServerApp = async (data) => {
    const response = await callApi({
        url: 'mcp/addmcpserverapp',
        method: MethodType.POST,
        data: { ...data },
    });

    if (!validateMCPApiResponse(response)) {
        throw new Error(response?.resp?.message ?? 'Failed to add MCP Server App');
    }
    return response.resp.data;
};

export const fetchMCPServerTools = async (mcpServerId) => {
    const response = await callApi({
        url: 'mcp/getmcptools',
        method: MethodType.GET,
        data: mcpServerId ? { mcp_server_id: mcpServerId } : undefined,
    });
    if (response.statusCode === 200) {
        return response.resp.data;
    }
    return [];
};

export const bulkAddMCPServerTools = async (mcpServerId, tools) => {
    const response = await callApi({
        url: 'mcp/bulkaddtools',
        method: MethodType.POST,
        data: { mcp_server_id: mcpServerId, tools },
    });

    if (!validateMCPApiResponse(response)) {
        const error = new Error(response.resp?.message ?? 'Failed to add MCP tools');
        error.rowErrors = response.resp?.data?.rowErrors;
        throw error;
    }
    return response.resp.data;
};

export const validateMCPApiResponse = (response) => {
    if (response.statusCode === 200) {
        return true;
    }
    if (response.statusCode === 201) {
        return true;
    }
    if (response.statusCode === 500) {
        return false;
    }
    return false;
};
